import { observable, action } from "mobx";
import {post} from "../services/ajax.service";

class DrugSearchStore {
    @observable containment_opportunities = {
      results: [],
      descriptions:{}
    }
    @action search = async (drug_name) => {
      this.containment_opportunities = {
        results: [],
        descriptions:{}
      }
        try {
            let response = await post(
              `/api/v1/drugsearchactions/search`, {drug_name, token: Math.random()*1000});
            if(response.data) {
            this.containment_opportunities = response.data;
            }
          } catch (err) {
            console.log(err);
          }
    }
  
}

export default DrugSearchStore;
